export default __webpack_public_path__ + "static/media/134.a4c7b2bc.png";